module.exports = __webpack_public_path__ + "static/media/google-button.0f4bf593.svg";